export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please provide a new name for the asset"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This name will help you identify the wallet more easily in your asset list."])}
}